import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { Subject, Subscription, throttleTime } from 'rxjs'
import {
  Card,
  DefenderDeclarationGame,
  defenderDeclarationGameNull,
  DefenderDeclarationService,
  DefendOptionType,
} from 'game-services'
import {
  DashboardComponent,
  DashboardUserAction,
} from '../dashboard/dashboard.component'
import { playerScoreCardNull } from 'game-play-services'

@Component({
  selector: 'sans-defender-declaration',
  standalone: true,
  imports: [DashboardComponent],
  templateUrl: './defender-declaration.component.html',
  styleUrl: './defender-declaration.component.scss',
})
export class DefenderDeclarationComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() public defenderDeclarationGame: DefenderDeclarationGame =
    defenderDeclarationGameNull

  @Input() public userPlayerScoreCard = playerScoreCardNull
  @Input() public leftOpponentPlayerScoreCard = playerScoreCardNull
  @Input() public rightOpponentPlayerScoreCard = playerScoreCardNull

  @Output() public gameUpdated = new EventEmitter<void>()

  private declareDefendOptionClicks = new Subject<DefendOptionType>()
  private declareDefendOptionClicksSubscription = new Subscription()

  public userDefendOptions: UserDefendOption[] = []
  public talonCards: Card[] = []
  public userCards: Card[] = []
  public rightOpponentCards: Card[] = []
  public leftOpponentCards: Card[] = []
  public userActions: DashboardUserAction[] = []

  public constructor(
    private readonly defenderDeclarationService: DefenderDeclarationService,
  ) {}

  public async ngOnInit(): Promise<void> {
    this.declareDefendOptionClicksSubscription = this.declareDefendOptionClicks
      .pipe(throttleTime(1000))
      .subscribe(async (defendOption) => {
        await this.defenderDeclarationService.declareDefendOption(
          this.defenderDeclarationGame.gamePlayGameId,
          defendOption,
        )
        this.gameUpdated.emit()
      })
  }

  public ngOnChanges(): void {
    this.userDefendOptions = this.defenderDeclarationGame.userDefendOptions.map(
      (defendOption) => {
        return {
          defendOptionType: defendOption.defendOptionType,
          defendOptionName: defendOption.getDefendOptionName(),
        }
      },
    )

    this.talonCards = this.defenderDeclarationGame.getTalonCards()
    this.userCards = this.defenderDeclarationGame.user.getCards()

    this.rightOpponentCards =
      this.defenderDeclarationGame.rightOpponent.originalCards

    this.leftOpponentCards =
      this.defenderDeclarationGame.leftOpponent.originalCards

    this.userActions = this.userDefendOptions.map((defendOption) => {
      return {
        buttonLabel: defendOption.defendOptionName,
        value: defendOption.defendOptionType,
      }
    })
  }

  public ngOnDestroy(): void {
    this.declareDefendOptionClicksSubscription.unsubscribe()
  }

  public async onUserActionSelected(
    userAction: DashboardUserAction,
  ): Promise<void> {
    this.declareDefendOptionClicks.next(userAction.value as DefendOptionType)
  }
}

interface UserDefendOption {
  readonly defendOptionType: DefendOptionType
  readonly defendOptionName: string
}
